import { Component, DestroyRef, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { BoardService } from '../../../../../services/board.service';
import { StackedSidebarService } from '../../../../../services/stacked-sidebar.service';
import { DialogService } from '../../../../../services/dialog.service';
import { NotificationService } from '../../../../../services/notifications.service';
import { SidebarType } from '../../../../layout/stacked-sidebar/stacked-sidebar.interface';
import { CardTimelineCallEvent } from '../../../board-v3.types';

@Component({
  selector: 'app-board-v3-timeline-call',
  templateUrl: './timeline-call.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BoardV3TimelineCallComponent {
  @Input() event!: CardTimelineCallEvent;
  @Output() callChanged = new EventEmitter<void>();

  private readonly boardService = inject(BoardService);
  private readonly stackedSidebarService = inject(StackedSidebarService);
  private readonly dialogService = inject(DialogService);
  private readonly notificationService = inject(NotificationService);
  private readonly translateService = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  get call() {
    return this.event.x_data;
  }

  formatDuration(durationMs: number): string {
    const totalSeconds = Math.round((durationMs || 0) / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  openTranscript(): void {
    this.stackedSidebarService
      .openSidebar({ type: SidebarType.BoardV3CallTranscript, width: '50vw' }, { callId: this.call.id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  onDeleteClick(): void {
    this.dialogService
      .openConfirm({ text: 'board_v3_calls_delete_confirm' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (!result) return;

        this.boardService
          .deleteCall(this.call.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: () => this.callChanged.emit(),
            error: () => {
              this.notificationService.showError('', this.translateService.instant('board_v3_calls_delete_error'));
            },
          });
      });
  }
}
